// src/Translator.js
import React, { useState } from 'react';
import axios from 'axios';
import './Translator.css';

const Translator = () => {
  const [text, setText] = useState('');
  const [language, setLanguage] = useState('es'); // default to Spanish (es)
  const [translatedText, setTranslatedText] = useState('');

  const handleTranslate = async () => {
    try {
      const response = await axios.post(
        'https://translation.googleapis.com/language/translate/v2',
        {},
        {
          params: {
            q: text,
            target: language,
            key: 'YOUR_API_KEY', // Replace with your Google Translate API key
          },
        }
      );
      setTranslatedText(response.data.data.translations[0].translatedText);
    } catch (error) {
      console.error('Error translating text:', error);
    }
  };

  return (
    <div className="translator-container">
      <h1>Translator App</h1>
      <textarea
        value={text}
        onChange={(e) => setText(e.target.value)}
        placeholder="Enter text to translate"
      />
      <select value={language} onChange={(e) => setLanguage(e.target.value)}>
        <option value="te">Telugu</option>
        <option value="hi">Hindi</option>
        <option value="ta">Tamil</option>
        <option value="kn">Kannada</option>
        <option value="ml">Malayalam</option>
        <option value="fr">French</option>
      </select>
      <button onClick={handleTranslate}>Translate</button>
      {translatedText && (
        <div className="translated-text">
          <h2>Translated Text:</h2>
          <p>{translatedText}</p>
        </div>
      )}
    </div>
  );
};

export default Translator;
